export default __webpack_public_path__ + "static/node_runner_tablet@2x-c635f4d34a3a4b9ad72a58abb56a3156.png";